import { Gamepad, Keyboard, or } from 'contro';
import Vec2 from 'gl-vec2';

const makeInput = () => {
  const keyboard = new Keyboard();
  const gamepad = new Gamepad();
  const controls = {
    reset: or(keyboard.key('Backspace'), keyboard.key('Escape'), gamepad.button('Start'), gamepad.button('Back')),
    up: or(keyboard.key('Up'), keyboard.key('W'), gamepad.button('Up')),
    down: or(keyboard.key('Down'), keyboard.key('S'), gamepad.button('Down')),
    left: or(keyboard.key('Left'), keyboard.key('A'), gamepad.button('Left')),
    right: or(keyboard.key('Right'), keyboard.key('D'), gamepad.button('Right')),
    jump: or(keyboard.key('Space'), gamepad.button('A')),
  };
  return () => {
    const movement = Vec2.fromValues(0, 0);
    if (gamepad.isConnected()) {
      const raw = gamepad.stick('left').query();
      const stick = Vec2.fromValues(raw.x, -raw.y);
      if (Vec2.length(stick) > 0.1) {
        Vec2.add(movement, movement, stick);
      }
    }
    if (controls.up.query()) movement[1] += 1;
    if (controls.down.query()) movement[1] -= 1;
    if (controls.left.query()) movement[0] -= 1;
    if (controls.right.query()) movement[0] += 1;
    if (Vec2.length(movement) > 1) Vec2.normalize(movement, movement);
    return { movement, jump: controls.jump.query(), reset: controls.reset.query() };
  };
};

export default makeInput;